module.exports = {
    customer: 'llm',
    assets: { logo: 'logo.svg' },
    sms_mode: true,
};